module.exports = __webpack_public_path__ + "img/title-en.7c8ed88d.webp";